import {
  Grid2 as Grid,
  Box,
  Typography,
  Button,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import SignUpOption from "../components/SignUpOption";
import constants from "../static/constants.json";
import { useState } from "react";
import { UserAPI } from "../apis/userApi";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/userSlice";
import { useNavigate } from "react-router";
import { extractNumbersFromString } from "../utils/utils";
import PhoneNumberInput from "../components/Inputs/PhoneNumberInput";

export default function SignUpWorker() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedJobTypes, setSelectedJobTypes] = useState([] as string[]);
  const [selectedHomeType, setSelectedHomeType] = useState("");
  const [selectedPersonType, setSelectedPersonType] = useState("");
  const [selectedZipCode, setSelectedZipCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedRadius, setSelectedRadius] = useState(0);
  const [receiveEmails, setReceiveEmails] = useState(true);
  const [receiveTexts, setReceiveTexts] = useState(false);
  const [address, setAddress] = useState({} as any);
  const [step, setStep] = useState(0);
  const optionItemStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const toggleSelectedJobType = (v: string) => {
    const newSelectedJobTypes = [...selectedJobTypes];
    const index = newSelectedJobTypes.indexOf(v);
    if (index > -1) {
      newSelectedJobTypes.splice(index, 1);
    } else {
      newSelectedJobTypes.push(v);
    }

    setSelectedJobTypes(newSelectedJobTypes);
  };

  const signUpUser = async () => {
    const body = {
      personTypeId: selectedPersonType,
      receiveEmails,
      receiveTexts,
      phoneNumber: extractNumbersFromString(phoneNumber),
    } as any;

    if (selectedPersonType === constants.personType.propertyManager) {
      body.address = address;
      body.propertyTypeId = selectedHomeType;
    }

    if (selectedPersonType === constants.personType.worker) {
      body.occupations = selectedJobTypes;
      body.zip = selectedZipCode;
      body.radius = selectedRadius;
    }

    try {
      const u = await UserAPI.createNewUser(body);
      dispatch(setUser(u));
      navigate("/");
    } catch (e: any) {
      console.log(e);
      console.log(e.response);
      console.log(e.response.data.message);
      alert(e.response.data.message);
      // if (e.message && e.message === "User exists") {
      //   alert("USER EXISTS ALREADY");
      // } else {
      //   alert(e.message);
      // }
    }
  };

  const buttonStyle = {
    width: "10rem",
    borderRadius: "1.25rem",
    fontFamily: "Arial",
  };

  const setAddressField = (fieldName: string, value: string) => {
    const newAddr = { ...address };
    newAddr[fieldName] = value;
    setAddress(newAddr);
  };

  // deciding if you are a manager or a worker
  const selectPersonTypeContent = (
    <Grid container sx={{}} spacing={2}>
      <Grid size={12}>
        <Typography variant="h4" style={{ textAlign: "center" }}>
          Select an option
        </Typography>
      </Grid>
      <Grid
        size={6}
        style={{
          display: "flex",
          alignItems: "center",

          justifyContent: "center",
        }}
      >
        <Box
          style={{
            borderRadius: "12px",
            border: "1px solid",
            width: "14rem",
            height: "14rem",
            padding: "2rem",
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "8rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px none",
            }}
          >
            <img width={"50%"} src="./property.png" alt="u" />
          </Box>
          <Typography variant="h6"> I'm a property manager</Typography>
          {/* <Typography>looking for workers</Typography> */}
          <Box
            style={{
              width: "100%",
              display: "flex",
              marginTop: "1rem",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              style={buttonStyle}
              onClick={() => {
                setSelectedPersonType(constants.personType.propertyManager);
                setStep(1);
              }}
            >
              {" "}
              Find workers
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid
        size={6}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          style={{
            borderRadius: "12px",
            border: "1px solid",
            width: "14rem",
            height: "14rem",
            padding: "2rem",
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "8rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img width={"50%"} src="./cleaner.png" alt="u" />
          </Box>
          <Typography variant="h6"> I'm a worker</Typography>
          {/* <Typography>looking for jobs</Typography> */}
          <Box
            style={{
              width: "100%",
              display: "flex",
              marginTop: "1rem",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              style={buttonStyle}
              onClick={() => {
                setSelectedPersonType(constants.personType.worker);
                setStep(10);
              }}
            >
              {" "}
              Find jobs
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );

  const selectPropertyTypeContent = (
    <Grid container sx={{}} spacing={2}>
      <Grid size={12}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          What type of property are you managing?
        </Typography>
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <SignUpOption
          selected={selectedHomeType === constants.propertyType.house}
          icon="house"
          label="House"
          onSelect={() => setSelectedHomeType(constants.propertyType.house)}
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <SignUpOption
          selected={selectedHomeType === constants.propertyType.apartment}
          icon="apartment"
          label="Apartment"
          onSelect={() => setSelectedHomeType(constants.propertyType.apartment)}
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <Button
          disabled={selectedHomeType === ""}
          variant="contained"
          style={{ ...buttonStyle, width: "50%" }}
          onClick={() => setStep(2)}
        >
          next
        </Button>
      </Grid>
    </Grid>
  );

  const textFieldStyle1 = {
    width: "100%",
  };
  const enterAddressContent = (
    <Grid container sx={{ width: "50%" }} spacing={2}>
      <Grid size={12}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          What is the property address?
        </Typography>
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <TextField
          style={textFieldStyle1}
          onChange={(e) => setAddressField("street1", e.target.value)}
          placeholder="Street Line 1"
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <TextField
          style={textFieldStyle1}
          onChange={(e) => setAddressField("street2", e.target.value)}
          placeholder="Street Line 2"
        />
      </Grid>
      <Grid size={4} style={optionItemStyle}>
        <TextField
          style={textFieldStyle1}
          onChange={(e) => setAddressField("city", e.target.value)}
          placeholder="City"
        />
      </Grid>
      <Grid size={4} style={optionItemStyle}>
        <TextField
          style={textFieldStyle1}
          onChange={(e) => setAddressField("state", e.target.value)}
          placeholder="State"
        />
      </Grid>
      <Grid size={4} style={optionItemStyle}>
        <TextField
          type="number"
          style={textFieldStyle1}
          onChange={(e) => setAddressField("zip", e.target.value)}
          placeholder="Zip"
        />
      </Grid>

      <Grid size={12} style={optionItemStyle}>
        <Button
          // disabled={selectedHomeType === ""}
          // variant="outlined"
          variant="contained"
          //  style={{...buttonStyle, width: '50%'}}
          style={{ width: "100%", height: "3rem", borderRadius: "1rem" }}
          onClick={() => setStep(20)}
        >
          next
        </Button>
      </Grid>
    </Grid>
  );

  const selectJobTypesContent = (
    <Grid container sx={{}} spacing={2} style={{ border: "1px none red" }}>
      <Grid size={12}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          What type of jobs are you looking for?
        </Typography>
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <SignUpOption
          selected={selectedJobTypes.indexOf(constants.occupation.cleaner) > -1}
          icon="cleaning"
          label="Housekeeping"
          onSelect={() => toggleSelectedJobType(constants.occupation.cleaner)}
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <SignUpOption
          selected={
            selectedJobTypes.indexOf(constants.occupation.landscaper) > -1
          }
          icon="landscaping"
          label="Landscaping"
          onSelect={() =>
            toggleSelectedJobType(constants.occupation.landscaper)
          }
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <SignUpOption
          selected={
            selectedJobTypes.indexOf(constants.occupation.handyman) > -1
          }
          icon="maintenance"
          label="Maintenance"
          onSelect={() => toggleSelectedJobType(constants.occupation.handyman)}
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <Button
          disabled={selectedJobTypes.length === 0}
          variant="contained"
          style={{ width: "50%", height: "3rem", borderRadius: "1rem" }}
          onClick={() => setStep(11)}
        >
          next
        </Button>
      </Grid>
    </Grid>
  );

  const selectWorkerAreaContent = (
    <Grid
      container
      sx={{}}
      spacing={2}
      style={{
        border: "1px none red",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid size={12}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          Where are you looking for jobs?
        </Typography>
      </Grid>
      <Grid
        size={12}
        style={{ ...optionItemStyle, width: "50%", border: "1px none" }}
      >
        <TextField
          label="Zip Code"
          onChange={(e) => setSelectedZipCode(e.target.value)}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid
        size={12}
        style={{ ...optionItemStyle, width: "50%", border: "1px none" }}
      >
        <TextField
          label="Radius (miles)"
          onChange={(e) => setSelectedRadius(parseInt(e.target.value))}
          style={{ width: "100%" }}
        />
      </Grid>

      <Grid size={12} style={optionItemStyle}>
        <Button
          disabled={selectedJobTypes.length === 0}
          variant="contained"
          style={{ width: "50%", height: "3rem", borderRadius: "1rem" }}
          onClick={() => setStep(20)}
        >
          next
        </Button>
      </Grid>
    </Grid>
  );

  const createProfileContent = (
    <Grid container sx={{}} spacing={2} style={{ border: "1px none red" }}>
      <Grid size={12}>
        <Typography variant="h6" style={{ textAlign: "center" }}>
          Choose a Sign-in Option
        </Typography>
      </Grid>
      {/*
      <Grid size={12} style={optionItemStyle}>
        <TextField style={textFieldStyle} label="First Name" />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <TextField style={textFieldStyle} label="Last Name" />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <TextField style={textFieldStyle} label="Email Address" />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <TextField style={textFieldStyle} label="Password" type="password" />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <Button
          disabled={selectedJobTypes.length === 0}
          variant="outlined"
          style={{ width: "50%", height: "3rem", borderRadius: "1rem" }}
          onClick={() => signUpUser()}
        >
          Sign up
        </Button>
      </Grid> */}
      <Grid size={12} style={optionItemStyle}>
        <GoogleLogin
          text="signup_with"
          width="208px"
          onSuccess={(credentialResponse) => {
            localStorage.setItem("token_type", "google");
            localStorage.setItem("token", credentialResponse.credential || "");
            signUpUser();
            // props.onCancel();
          }}
          onError={() => {
            alert("Login Failed");
          }}
        />
      </Grid>
      <Grid size={12} style={optionItemStyle}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={receiveEmails}
                onChange={(e) => setReceiveEmails(e.target.checked)}
              />
            }
            label="Receive emails"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={receiveTexts}
                onChange={(e) => setReceiveTexts(e.target.checked)}
              />
            }
            label="Receive texts"
          />
          {receiveTexts ? (
            <FormControlLabel
            control={
             <PhoneNumberInput value={phoneNumber} onChange={(v) => setPhoneNumber(v)} />
            }
            label="phone"
          />
          ): null}
          
          
        </FormGroup>
      </Grid>
    </Grid>
  );

  const getStepContent = () => {
    switch (step) {
      // step 0 is selecting if manager
      case 0:
        return selectPersonTypeContent;
      case 1:
        return selectPropertyTypeContent;
      case 2:
        return enterAddressContent;
      // step 10 starts the worker steps
      case 10:
        return selectJobTypesContent;
      case 11:
        return selectWorkerAreaContent;

      case 20:
        return createProfileContent;
      default:
        return <></>;
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          marginTop: "4rem",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {getStepContent()}
      </Box>
    </>
  );
}
